import React from 'react';
import PropTypes from 'prop-types';

import SearchPage from 'components/search_page';
import FilterTopbar from 'components/search_page/filter_topbar';
import FilterRow from 'components/search_page/filter_row';
import SelectFilter from 'components/search_sidebar/select_filter';
import ContactRolePropTypes from 'bundles/project/prop_types/contact_roles';

export default function CompaniesFilterTopbar({
  companyCount,
  currentPage,
  isLoading,
  pageSize,
  relationshipFilter,
  relationshipOptions,
  searchText,
  totalCount,
  onRelationshipChange,
  onSearchChange
}) {
  if (isLoading) return null;

  const pageData = {
    currentPage,
    itemCount: companyCount,
    itemSingularLabel: 'company',
    pageSize,
    totalCount
  };

  return (
    <SearchPage>
      <FilterTopbar className="w-100 p-0 border-0 mb-3">
        <FilterRow
          name="filters"
          pageData={pageData}
          searchPlaceholder="Search by name"
          searchText={searchText}
          onSearchChange={onSearchChange}
        >
          <div className="left-buffer-md">
            <SelectFilter
              defaultValue={relationshipOptions[0]}
              getOptionValue={option => option.id}
              name="relationship-filter"
              options={relationshipOptions}
              value={relationshipFilter}
              onChange={onRelationshipChange}
            />
          </div>
        </FilterRow>
      </FilterTopbar>
    </SearchPage>
  );
}

CompaniesFilterTopbar.propTypes = {
  companyCount: PropTypes.number,
  currentPage: PropTypes.number,
  isLoading: PropTypes.bool,
  pageSize: PropTypes.number,
  relationshipFilter: PropTypes.object,
  relationshipOptions: ContactRolePropTypes,
  searchText: PropTypes.string,
  totalCount: PropTypes.number,
  onRelationshipChange: PropTypes.func,
  onSearchChange: PropTypes.func
};
